<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["Id", "DataTalep", "TalepTitle"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},
      TableData: [],
      Onaydurum: {
        1: "Onaylandı",
        2: "Red",
        3: "Satınalmaya Yönlendirildi",
      },
    };
  },
  components: {
    Loader,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get();
    },
  },
  methods: {
    onSubmit() {
      this.ActionsPutList({
        Service: "SatTalepMalzeme/PutList",
        Data: this.TableData,
      }).then((res) => {
        if (res.Succeeded == true) {
          var SatinAlmaKontrol = false;
          for (var i = 0; i < this.TableData.length; i++) {
            if (this.TableData[i].Onaydurum == 3) {
              SatinAlmaKontrol = true;
            }
          }
          if (SatinAlmaKontrol) {
            this.DataTalep.Onaydurum = 5;
          } else {
            this.DataTalep.Onaydurum = 3;
          }

          this.Update("sattalep", this.DataTalep).then((response) => {
          if(response){
            
          this.$emit("TableUpdate");
              this.$bvModal.hide("sattaleponay");
          }
          }) 
        } else {
          this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
        }
      });
    },
    Get() {
      if (this.DataTalep.Id) {
        this.ActionsFilterGet({
          Service: "SatTalepMalzeme",
          Page: this.Page,
          Filter: "&Asc=Sirano&Talepid=" + this.Id,
        }).then((res) => {
          this.TableData = res.Data;
        });
      }
    },
    TumunuKarsila() {
      for (var i = 0; i < this.TableData.length; i++) {
        this.TableData[i].Depokarsilananadet = this.TableData[i].Adet;
        this.TableData[i].Onaydurum = 1;
      }
      this.$emit("TableUpdate");
    },
    TumunuKarsilaIptal() {
      for (var i = 0; i < this.TableData.length; i++) {
        this.TableData[i].Depokarsilananadet = 0;
        this.TableData[i].Onaydurum = 3;
      }
      this.$emit("TableUpdate");
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="sattaleponay"
      size="lg"
      :title="TalepTitle"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead class="table-light">
              <tr>
                <th rowspan="2">
                  {{ $t("sattaleponay.MalzemeTable.Sirano") }}
                </th>
                <th rowspan="2">
                  {{ $t("sattaleponay.MalzemeTable.Malzemeadi") }}
                </th>
                <th rowspan="2">{{ $t("sattaleponay.MalzemeTable.Olcubirimivalue") }}</th>
                <th rowspan="2">{{ $t("sattaleponay.MalzemeTable.Adet") }}</th>
                <th>
                  {{ $t("sattaleponay.MalzemeTable.Depokarsilananadet")
                  }}
                </th>
                <th rowspan="2">
                  {{ $t("sattaleponay.MalzemeTable.KarsilamaDurumu") }}
                </th>
                <th v-if="DataTalep.Onaydurum == 2" style="width: 80px; text-align: center;">
                  {{ $t("sattaleponay.MalzemeTable.Islem") }}
                </th>
              </tr>
              <tr></tr>
            </thead>
            <tbody>
              <tr v-for="Data in TableData" :key="Data.Id">
                <th scope="row">{{ Data.Sirano }}</th>
                <th scope="row">
                  {{ Data.Malzemeadi }}
                  <template v-if="Data.Malzemeaciklama">
                    - {{ Data.Malzemeaciklama }}
                  </template>
                </th>
                <th scope="row">{{ Data.Olcubirimivalue }}</th>
                <th scope="row">{{ Data.Adet }}</th>
                <th scope="row">
                  <input
                    :disabled="Data.Onaydurum == 2 || DataTalep.Onaydurum != 2"
                    v-model="Data.Depokarsilananadet"
                    type="number"
                    class="form-control"
                    min="0"
                    :max="Data.Adet"
                    @input="
                      () => {
                        if (Data.Depokarsilananadet == Data.Adet) {
                          Data.Onaydurum = 1;
                        } else if (
                          Data.Depokarsilananadet != 0 &&
                          Data.Depokarsilananadet != Data.Adet
                        ) {
                          Data.Onaydurum = 3;
                        } else {
                          Data.Onaydurum = 3;
                        }
                      }
                    "
                  />
                </th>
                <th>
                  <span style="color: red"
                    >({{ Data.Adet - Data.Depokarsilananadet }})</span
                  >
                  {{ Onaydurum[Data.Onaydurum] }}
                </th>
                <th v-if="DataTalep.Onaydurum == 2" style="width: 80px; text-align: center;">

                  <b-button-group>
                    <b-button variant="danger" @click="(Data.Onaydurum = 2), (Data.Depokarsilananadet = 0)" v-if="Data.Onaydurum != 2" v-tooltip="$t('sattaleponay.MalzemeTable.MalzemeIptal')"><i class="fas fa-window-close"></i></b-button>
                    <b-button variant="danger"  @click="Data.Onaydurum = 3" v-if="Data.Onaydurum == 2" v-tooltip="$t('sattaleponay.MalzemeTable.MalzemeIptalKaldir')"><i class="far fa-window-close"></i></b-button>
                  </b-button-group>

                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between item-align-center mt-4">
          <div>
            <button v-if="DataTalep.Onaydurum == 2" class="btn btn-primary" type="submit">
            {{ $t("sattaleponay.AddEdit.Button") }}
          </button>
          </div>
          <div>
            
            <button v-if="DataTalep.Onaydurum == 2" @click="TumunuKarsila()" class="btn btn-success mx-2" type="submit" v-tooltip="$t('sattaleponay.MalzemeTable.TumunuKarsila')">
              {{ $t('sattaleponay.MalzemeTable.TumunuKarsila') }}
            </button>
            <button v-if="DataTalep.Onaydurum == 2" @click="TumunuKarsilaIptal()" class="btn btn-danger" type="submit" v-tooltip="$t('sattaleponay.MalzemeTable.TumunuKarsilaIptal')">
              {{ $t('sattaleponay.MalzemeTable.TumunuKarsilaIptal') }}
            </button>
          </div>
        </div>
      </Form>
    </b-modal>
  </Loader>
</template>
